import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { BaseButton } from '../components/base-button/Component.js';

var defaultColors = {"primary":"button__primary_121qb","loader":"button__loader_121qb","secondary":"button__secondary_121qb","text":"button__text_121qb","ghost":"button__ghost_121qb","component":"button__component_121qb","loading":"button__loading_121qb","outlined":"button__outlined_121qb","tertiary":"button__tertiary_121qb","transparent":"button__transparent_121qb","link":"button__link_121qb"};
require('./default.mobile.css')

var invertedColors = {"primary":"button__primary_l31xo","loader":"button__loader_l31xo","secondary":"button__secondary_l31xo","text":"button__text_l31xo","ghost":"button__ghost_l31xo","component":"button__component_l31xo","loading":"button__loading_l31xo","outlined":"button__outlined_l31xo","tertiary":"button__tertiary_l31xo","transparent":"button__transparent_l31xo","link":"button__link_l31xo"};
require('./inverted.mobile.css')

var styles = {"size-32":"button__size-32_10dt6","size-40":"button__size-40_10dt6","size-48":"button__size-48_10dt6","size-56":"button__size-56_10dt6","size-64":"button__size-64_10dt6","size-72":"button__size-72_10dt6"};
require('./mobile.css')

var colorStyles = {
    default: defaultColors,
    inverted: invertedColors,
};
var ButtonMobile = forwardRef(function (restProps, ref) { return (React.createElement(BaseButton, __assign({}, restProps, { ref: ref, colorStylesMap: colorStyles, styles: styles }))); });

export { ButtonMobile };
